function dataTransLate(type,list) {
    let newList  = []
    list.forEach((item)=>{
        let data = {
            name: item.key,
            type: type,
            data: item.value
        }
        newList.push(data)
    })
    return newList
}

module.exports = {
    dataTransLate: function(type,list) {
        let newList  = {}
        let data = []
        let axis = []
        let legend = []
        list.forEach((item)=>{
            legend.push(item.key)
            if(item.value&&item.value.length>0) {
                let s2 = item.value
                s2.sort(function(a,b){
                    return a.key-b.key;
                })
                s2.forEach((item1)=>{
                    if(axis.indexOf(item1.key)<0) {
                        axis.push(item1.key)
                    }
                })
                
            }
        })
        axis.sort(function(a,b){
            var start = parseInt(a);
            var end = parseInt(b);
            return start-end;
        })
        list.forEach((item)=>{
            if(item.value&&item.value.length>0) {
                let s2 = item.value
                s2.sort(function(a,b){
                    return a.key-b.key;
                })
                let newS2 = []
                axis.forEach((item3)=>{
                    let obj = {}
                    obj.key= item3
                    obj.value = 0
                    s2.forEach((item1)=>{
                        if(obj.key==item1.key) {
                            obj.value = item1.value
                        }
                    })
                    newS2.push(obj)
                })
                let s1 = {
                    name: item.key,
                    type: type,
                    data: newS2
                }
                data.push(s1) 
                
            }
        })
        newList = {
            'legend': legend,
            'data': data,
            'axis': axis
        }
        return newList
    }
}